import { useSelector } from "react-redux";
import NtwRepTemplateTable from "../NtwContentOptions/NtwRepTemplateTable";
import NtwCopyTemplate from "../NtwContentOptions/NtwCopyTemplate";
import NewInboundTemplateOptions from "../../../../constants/newTemplateWizardOptions";
import NtwDTDTemplate from "../NtwContentOptions/NtwDTDTemplate";
import NtwRepTemplateList from "../NtwContentOptions/NtwRepTemplateList";
import NtwSqlTemplate from "../NtwContentOptions/NtwSqlTemplate";
import NtwJSONTemplate from "../NtwContentOptions/NtwJSONTemplate";
import NtwEdiSefTemplate from "../NtwContentOptions/NtwEdiSefTemplate";
import NtwDelimitedHeaderTemplate from "../NtwContentOptions/NtwDelimitedHeaderTemplate";
import NtwXSDTemplate from "../NtwContentOptions/NtwXSDTemplate";
import NtwXMLDataTemplate from "../NtwContentOptions/NtwXMLDataTemplate";
import { Divider } from "@mui/material";

export default function NtwOptions() {
  const newTemplate = useSelector((state) => state.newTemplate);
  const repoTemplate =newTemplate.RepTemplateDetails;
  const ntOption = NewInboundTemplateOptions();
  const ntCopySelectedTemplate = ntOption.NTW_COPY_SELECTED_TEMPLATE;
  const ntDTDTemplateCreation = ntOption.NTW_DTD_TEMPLATE;
  const ntEDITemplateCreation = ntOption?.NTW_REP_EDI_TEMPLATES;
  const ntNCPDPTemplateCreation = ntOption?.NTW_REP_NCPDP_TEMPLATES;
  const ntHL7TemplateCreation = ntOption?.NTW_REP_HL7_TEMPLATES;
  const ntFHIRTemplateCreation = ntOption?.NTW_REP_FHIR_TEMPLATES;
  const ntXMLRepTemplateCreation = ntOption?.NTW_REP_XML_TEMPLATES;
  const ntSqlTemplateCreation = ntOption?.NTW_SQL_TEMPLATE;
  const ntJSONDataTemplateCreation = ntOption.NTW_JSON_DATA;
  const ntJSONSchemaTemplateCreation = ntOption.NTW_JSON_SCHEMA;
  const ntEdiSefTemplateCreation = ntOption.NTW_EDI_SEF;
  const ntDelimitedHeaderTemplateCreation = ntOption.NTW_DELIMITED_HEADER;
  const ntXSDTemplateCreation = ntOption.NTW_XSD;
  const ntXMLDataTemplateCreation = ntOption.NTW_XML_DATA;
  const newTemplateOptions = {
    [ntCopySelectedTemplate]: <NtwCopyTemplate />,
    [ntDTDTemplateCreation] : <NtwDTDTemplate />,
    [ntSqlTemplateCreation] : <NtwSqlTemplate />,
    [ntJSONDataTemplateCreation] :<NtwJSONTemplate key={0}/>,
    [ntJSONSchemaTemplateCreation] :<NtwJSONTemplate key={1}/>,
    [ntEdiSefTemplateCreation] : <NtwEdiSefTemplate/>,
    [ntDelimitedHeaderTemplateCreation] : <NtwDelimitedHeaderTemplate/>,
    [ntXSDTemplateCreation] : <NtwXSDTemplate/>,
    [ntXMLDataTemplateCreation] : <NtwXMLDataTemplate />,
    ...ntFHIRTemplateCreation?.reduce((acc, item) => {
      return {
        ...acc,
        [item]: <NtwRepTemplateList key = {item} path={repoTemplate.path} repo_type='FHIR' />,
      };
    }, {}) || {}, 
    ...ntEDITemplateCreation?.reduce((acc, item) => {
      return {
        ...acc,
        [item]: <NtwRepTemplateTable key={item} path={repoTemplate.path} version={repoTemplate.title} repo_type='EDI' />,
      };
    }, {}) || {}, 
    ...ntNCPDPTemplateCreation?.reduce((acc, item) => {
      return {
        ...acc,
        [item]: <NtwRepTemplateTable key={item} path={repoTemplate.path} version={repoTemplate.title} repo_type='NCPDP' />,
      };
    }, {}) || {} ,
    ...ntHL7TemplateCreation ?.reduce((acc, item) => {
      return {
        ...acc,
        [item]: <NtwRepTemplateList key={item} path={repoTemplate.path} release_key={25} repo_type='HL7' version={repoTemplate.title} src={'hl7Rep'} />,
      };
    }, {}) || {} , 
    ...ntXMLRepTemplateCreation ?.reduce((acc, item) => {
      return {
        ...acc,
        [item]: <NtwRepTemplateList key={item} path={repoTemplate.path}  repo_type='XML' version={repoTemplate.title} />,
      };
    }, {}) || {} , 
    
  };
  const renderComponent = (option) => {
    return newTemplateOptions[option] || null;
  };
  const content = renderComponent(newTemplate.newTemplateOption);
  return (
    <>
      {content !== null && (
        <>
          <div className="padding-12" style={{maxHeight: "calc(100% - 120px)"}}>
            {content}
          </div>
          <div className="padding-hor-12">
            <Divider/>
          </div>
        </>
      )}
      
    </>
    
  )
}